import React, { ElementType, Fragment } from 'react'

import { Image } from './Image'
import { AssetProps } from './types'
import { Video } from './Video'

export const Asset: React.FC<AssetProps> = props => {
  const { className, resource, htmlElement = 'div', style } = props

  const isVideo = typeof resource !== 'string' && resource?.mimeType?.includes('video')
  const Tag = (htmlElement as ElementType) || Fragment

  return (
    <Tag {...(htmlElement !== null ? { className, style } : {})}>
      {isVideo ? <Video {...props} /> : <Image {...props} />}
    </Tag>
  )
}
